exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".input-e04cd{padding:8px 12px;border-radius:8px}", ""]);

// Exports
exports.locals = {
	"input": "input-e04cd"
};